<template>
  <div class="my-order" ref="container">
    <div class="input">
      <input
        :placeholder="'任务名称/订单号'"
        v-model="post.param"
        style="width: 6rem;background-color: white;border-radius: 1rem;margin-top: 0.3rem;margin-left: 0.3rem;font-size: 0.26rem;"
      />
      <div
        class="button"
        @click="searchTask()"
        style="margin-top: -0.35rem;margin-left: 6.6rem;font-size: 0.26rem;color: rgb(208, 56, 56);"
      >
        搜索
      </div>
    </div>
    <div class="nav1 acea-row row-around"></div>
    <div
      class="nav2 acea-row row-around"
      style="margin-top: 0.2rem;background-color: white;height: 1.3rem;"
    >
      <div class="item" :class="{ onClick: type === 0 }" @click="changeType(0)">
        <div
          style="font-size: 0.26rem;margin-bottom: 0.3rem;padding-top: 0.2rem;"
        >
          总任务数
        </div>
        <div class="num" style="font-size: 0.26rem; text-align: center;">
          {{ allTaskNumber || 0 }}
        </div>
      </div>
      <div class="item" :class="{ onClick: type === 1 }" @click="changeType(1)">
        <div
          style="font-size: 0.26rem;margin-bottom: 0.3rem;padding-top: 0.2rem;"
        >
          审核中
        </div>
        <div class="num" style="font-size:0.26rem; text-align: center;">
          {{ effectTaskNumber || 0 }}
        </div>
      </div>
      <div class="item" :class="{ onClick: type === 4 }" @click="changeType(4)">
        <div
          style="font-size: 0.26rem;margin-bottom: 0.3rem;padding-top: 0.2rem;"
        >
          审核失败
        </div>
        <div class="num" style="font-size:0.26rem; text-align: center;">
          {{ failTaskNumber || 0 }}
        </div>
      </div>
      <div class="item" :class="{ onClick: type === 2 }" @click="changeType(2)">
        <div
          style="font-size: 0.26rem;margin-bottom: 0.3rem;padding-top: 0.2rem;"
        >
          待完成
        </div>
        <div class="num" style="font-size:0.26rem; text-align: center;">
          {{ noTaskNumber || 0 }}
        </div>
      </div>
      <div class="item" :class="{ onClick: type === 3 }" @click="changeType(3)">
        <div
          style="font-size: 0.26rem;margin-bottom: 0.3rem;padding-top: 0.2rem;"
        >
          已完成
        </div>
        <div class="num" style="font-size:0.26rem; text-align: center;">
          {{ doneTaskNumber || 0 }}
        </div>
      </div>
    </div>
    <div class="list">
      <div class="task-detail">
        <div v-if="type === 0">
          <template v-for="(taskOrder, allTaskOrderIndex) in allTaskOrder">
            <div
              class="item"
              :key="allTaskOrderIndex"
              style="height: 1.59rem;font-size: 0.26rem;"
            >
              <div
                class="text"
                style="width: 3.2rem;margin-left: 0.1rem;margin-bottom: -0.99rem;"
              >
                <div
                  style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;height: fit-content;margin-left: 1.4rem;padding-top: 0.53rem;width: 3rem;"
                >
                  {{ taskOrder.taskName }}
                </div>
                <div
                  style="margin-left: 1.4rem;width: 3rem;margin-bottom: -0.55rem; color: red;"
                >
                  +{{ taskOrder.returnPrice }}
                </div>
                <div
                  v-if="taskOrder.taskStatus === -2"
                  style="margin-left: 5.25rem;width: 1rem;height: 0.36rem;"
                >
                  审核中
                </div>
                <div
                  v-if="taskOrder.taskStatus === -1"
                  style="margin-left: 5.25rem;width: 1rem;height: 0.36rem;color: red;"
                  @click="goPages(taskOrder)"
                >
                  去完成
                </div>
                <div
                  v-if="taskOrder.taskStatus === 0"
                  style="margin-left: 5.25rem;width: 1.5rem;height: 0.36rem;"
                >
                  <div>已完成</div>
                  <div style="color: #00AAEA;" @click="goReason(taskOrder)">
                    未返金
                  </div>
                </div>
                <div
                  v-if="taskOrder.taskStatus === 1"
                  style="margin-left: 5.25rem;width: 1.5rem;height: 0.36rem;"
                  @click="goPages(taskOrder)"
                >
                  <div>已完成</div>
                  <div>已返金</div>
                </div>
              </div>
              <div class="number" style="margin-bottom: 0.07rem;">
                <div
                  v-if="taskOrder.orderId !== null"
                  style="text-align: left; width: auto; height: 0.05rem;"
                >
                  订单号：{{ taskOrder.orderId }}
                </div>
                <div
                  v-if="taskOrder.orderId == null"
                  style="text-align: left; width: auto; height: 0.05rem;"
                >
                  订单号：
                </div>
                <div style="text-align: right;margin-bottom: -0.05rem;">
                  {{ taskOrder.createTime | capitalize }}
                </div>
              </div>
              <div class="image">
                <img
                  :src="taskOrder.taskImage"
                  style="height: 1rem;width: 1.4rem;"
                />
              </div>
            </div>
          </template>
        </div>
        <template v-if="type === 1">
          <div
            class="item"
            v-for="(taskOrder, effectTaskOrderIndex) in effectTaskOrder"
            :key="effectTaskOrderIndex"
          >
            <div
              class="item"
              :key="effectTaskOrderIndex"
              @click="goPages(taskOrder)"
              style="height: 1.59rem;font-size: 0.26rem;"
            >
              <div
                class="text"
                style="width: 3.2rem;margin-left: 0.1rem;margin-bottom: -0.99rem;"
              >
                <div
                  style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;height: fit-content;margin-left: 1.4rem;padding-top: 0.53rem;width: 3rem;"
                >
                  {{ taskOrder.taskName }}
                </div>
                <div
                  style="margin-left: 1.4rem;width: 3rem;margin-bottom: -0.55rem;color: red;"
                >
                  +{{ taskOrder.returnPrice }}
                </div>
                <div style="margin-left: 5.25rem;width: 1rem;height: 0.36rem;">
                  审核中
                </div>
              </div>
              <div class="number" style="margin-bottom: 0.07rem;">
                <div
                  v-if="taskOrder.orderId !== null"
                  style="text-align: left; width: auto; height: 0.05rem;"
                >
                  订单号：{{ taskOrder.orderId }}
                </div>
                <div
                  v-if="taskOrder.orderId == null"
                  style="text-align: left; width: auto; height: 0.05rem;"
                >
                  订单号：
                </div>
                <div style="text-align: right;margin-bottom: -0.05rem;">
                  {{ taskOrder.createTime | capitalize }}
                </div>
              </div>
              <div class="image">
                <img
                  :src="taskOrder.taskImage"
                  style="height: 1rem;width: 1.4rem;"
                />
              </div>
            </div>
          </div>
        </template>
        <template v-if="type === 2">
          <div
            class="item"
            v-for="(taskOrder, noTaskOrderIndex) in noTaskOrder"
            :key="noTaskOrderIndex"
          >
            <div
              class="item"
              :key="noTaskOrderIndex"
              @click="goPages(taskOrder)"
              style="height: 1.59rem;font-size: 0.26rem;"
            >
              <div
                class="text"
                style="width: 3.2rem;margin-left: 0.1rem;margin-bottom: -0.99rem;"
              >
                <div
                  style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;height: fit-content;margin-left: 1.4rem;padding-top: 0.53rem;width: 3rem;"
                >
                  {{ taskOrder.taskName }}
                </div>
                <div
                  style="margin-left: 1.4rem;width: 3rem;margin-bottom: -0.55rem;color: red;"
                >
                  +{{ taskOrder.returnPrice }}
                </div>
                <div
                  v-if="taskOrder.taskStatus === -1"
                  style="margin-left: 5.25rem;width: 1rem;height: 0.36rem;color: red;"
                  @click="goPages(taskOrder)"
                >
                  去完成
                </div>
              </div>
              <div class="number" style="margin-bottom: 0.07rem;">
                <div
                  v-if="taskOrder.orderId !== null"
                  style="text-align: left; width: auto; height: 0.05rem;"
                >
                  订单号：{{ taskOrder.orderId }}
                </div>
                <div
                  v-if="taskOrder.orderId == null"
                  style="text-align: left; width: auto; height: 0.05rem;"
                >
                  订单号：
                </div>
                <div style="text-align: right;margin-bottom: -0.05rem;">
                  {{ taskOrder.createTime | capitalize }}
                </div>
              </div>
              <div class="image">
                <img
                  :src="taskOrder.taskImage"
                  style="height: 1rem;width: 1.4rem;"
                />
              </div>
            </div>
          </div>
        </template>
        <template v-if="type === 3">
          <div
            class="item"
            v-for="(taskOrder, doneTaskOrderIndex) in doneTaskOrder"
            :key="doneTaskOrderIndex"
          >
            <div
              class="item"
              :key="doneTaskOrderIndex"
              style="height: 1.59rem;font-size: 0.26rem;"
            >
              <div
                class="text"
                style="width: 3.2rem;margin-left: 0.1rem;margin-bottom: -0.99rem;"
              >
                <div
                  style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;height: fit-content;margin-left: 1.4rem;padding-top: 0.53rem;width: 3rem;"
                >
                  {{ taskOrder.taskName }}
                </div>
                <div
                  style="margin-left: 1.4rem;width: 3rem;margin-bottom: -0.55rem;color: red;"
                >
                  +{{ taskOrder.returnPrice }}
                </div>
                <div
                  v-if="taskOrder.taskStatus === 1"
                  style="margin-left: 5.25rem;width: 1.5rem;height: 0.36rem;"
                  @click="goPages(taskOrder)"
                >
                  <div>已完成</div>
                  <div>已返金</div>
                </div>
                <div
                  v-if="taskOrder.taskStatus === 0"
                  style="margin-left: 5.25rem;width: 1.5rem;height: 0.36rem;"
                >
                  <div>已完成</div>
                  <div style="color: #00AAEA;" @click="goReason(taskOrder)">
                    未返金
                  </div>
                </div>
              </div>
              <div class="number" style="margin-bottom: 0.07rem;">
                <div
                  v-if="taskOrder.orderId !== null"
                  style="text-align: left; width: auto; height: 0.05rem;"
                >
                  订单号：{{ taskOrder.orderId }}
                </div>
                <div
                  v-if="taskOrder.orderId == null"
                  style="text-align: left; width: auto; height: 0.05rem;"
                >
                  订单号：
                </div>
                <div style="text-align: right;margin-bottom: -0.05rem;">
                  {{ taskOrder.createTime | capitalize }}
                </div>
              </div>
              <div class="image">
                <img
                  :src="taskOrder.taskImage"
                  style="height: 1rem;width: 1.4rem;"
                />
              </div>
            </div>
          </div>
        </template>
        <template v-if="type === 4">
          <div
            class="item"
            v-for="(taskOrder, failTaskOrderIndex) in failTaskOrder"
            :key="failTaskOrderIndex"
          >
            <div
              class="item"
              :key="failTaskOrderIndex"
              @click="goPages(taskOrder)"
              style="height: 2.2rem;font-size: 0.2rem;"
            >
              <div
                class="text"
                style="width: 3.2rem;margin-left: 0.1rem;margin-bottom: -0.99rem;"
              >
                <div
                  style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;height: fit-content;margin-left: 1.4rem;padding-top: 0.53rem;width: 3rem;"
                >
                  {{ taskOrder.taskName }}
                </div>
                <div
                  style="margin-left: 1.4rem;width: 5rem;margin-bottom: -1.35rem;color: red;"
                >
                  +{{ taskOrder.returnPrice }}
                  <div>审核失败原因：{{ taskOrder.remarks }}</div>
                </div>
              </div>
              <div class="number" style="margin-bottom: 0.07rem;">
                <div
                  v-if="taskOrder.orderId !== null"
                  style="text-align: left; width: auto; height: 0.05rem;"
                >
                  订单号：{{ taskOrder.orderId }}
                </div>
                <div
                  v-if="taskOrder.orderId == null"
                  style="text-align: left; width: auto; height: 0.05rem;"
                >
                  订单号：
                </div>
                <div style="text-align: right;margin-bottom: -0.05rem;">
                  {{ taskOrder.createTime | capitalize }}
                </div>
              </div>
              <div class="image">
                <img
                  :src="taskOrder.taskImage"
                  style="height: 1rem;width: 1.4rem;"
                />
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { getTaskOrder, postTaskOrder } from "../../api/user";

import { takeOrderHandle } from "@/libs/order";
import { mapGetters } from "vuex";

const NAME = "UserTask";

export default {
  name: NAME,
  data: function() {
    return {
      post: {
        param: "",
        name: ""
      },
      allTaskOrder: [],
      allTaskNumber: 0,
      effectTaskOrder: [],
      effectTaskNumber: 0,
      failTaskOrder: [],
      failTaskNumber: 0,
      noTaskOrder: [],
      noTaskNumber: 0,
      doneTaskOrder: [],
      doneTaskNumber: 0,
      type: parseInt(this.$route.params.type) || 0,
      identification: false
    };
  },

  watch: {
    $route(n) {
      this.getTask();
      if (n.name === NAME) {
        const type = parseInt(this.$route.params.type) || 0;
        if (this.type !== type) {
          this.changeType(type);
        }
      }
    }
  },
  computed: mapGetters(["isLogin", "location", "userInfo"]),
  filters: {
    capitalize: function(value) {
      var date = new Date(parseInt(value));
      var tt =
        [
          date.getFullYear(),
          date.getMonth() + 1 < 10
            ? "0" + (date.getMonth() + 1)
            : date.getMonth() + 1,
          date.getDate() < 10 ? "0" + date.getDate() : date.getDate()
        ].join("-") +
        "  " +
        [
          date.getHours() < 10 ? "0" + date.getHours() : date.getHours(),
          date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes(),
          date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds()
        ].join(":");
      return tt;
    }
  },
  mounted() {
    this.getTask();
  },
  methods: {
    goReason: function(taskOrder) {
      this.$dialog.message(taskOrder.remarks, 10000);
    },
    goPages: function(taskOrder) {
      let url = taskOrder.h5Url;
      if (this.userInfo.realName) {
        if (url) {
          window.location.href = url;
        } else {
          this.$dialog.error("操作失败，请重试！");
        }
      } else {
        this.$router.push({
          path: "/user/identification",
          query: { url: url }
        });
      }
    },
    getTask: function() {
      let that = this;
      getTaskOrder().then(res => {
        that.allTaskOrder = res.data.All_Task_Order;
        that.allTaskNumber = res.data.All_Task_Number;
        that.effectTaskOrder = res.data.Effect_Task_Order;
        that.effectTaskNumber = res.data.Effect_Task_Order_Number;
        that.failTaskOrder = res.data.Fail_Task_Order;
        that.failTaskNumber = res.data.Fail_Task_Order_Number;
        that.noTaskOrder = res.data.No_Task_Order;
        that.noTaskNumber = res.data.No_Task_Order_Number;
        that.doneTaskOrder = res.data.Done_Task_Order;
        that.doneTaskNumber = res.data.Done_Task_Order_Number;
      });
    },
    reload() {
      this.changeType(this.type);
    },
    changeType(type) {
      this.type = type;
    },
    searchTask: function() {
      let save = {
          param: this.post.param
        },
        that = this;

      postTaskOrder(save).then(res => {
        that.allTaskOrder = res.data.All_Task_Order;
        that.allTaskNumber = res.data.All_Task_Number;
        that.effectTaskOrder = res.data.Effect_Task_Order;
        that.effectTaskNumber = res.data.Effect_Task_Order_Number;
        that.failTaskOrder = res.data.Fail_Task_Order;
        that.failTaskNumber = res.data.Fail_Task_Order_Number;
        that.noTaskOrder = res.data.No_Task_Order;
        that.noTaskNumber = res.data.No_Task_Order_Number;
        that.doneTaskOrder = res.data.Done_Task_Order;
        that.doneTaskNumber = res.data.Done_Task_Order_Number;
      });
    }
  }
};
</script>
<style>
.onClick {
  font-weight: bold;
  border-bottom: 0.05rem solid #eb3729;
}
</style>
